<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align: center;">A.D Gibson is a writer from Northern Ireland. Before she started writing fantasy fiction, she completed a Bachelor of Business Administration at the University of Strathclyde in Glasgow. She now spends her time living and working in her native city of Belfast.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?0ff47828